(function() {
  let pickyWidget = document.querySelector('.picky-qb-bundle');
  const onPickyExists = () => {
    const productElement = pickyWidget.closest('.product')

    // First, we select the first option
    const firstOption = pickyWidget.querySelector('.picky-qb-bundle__qb-offer-item');
    if (firstOption) {
      firstOption.click();
    }

    /* Then we hook on the button, so adding to cart triggers a cart update */
    const addButton = pickyWidget.querySelector('.picky-qb-bundle__button');
    if (addButton) {
      let isLoading = false;
      // MutationObserver to watch for loading state changes. The class is `_button_loading_1l329_83`
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const currentlyLoading = addButton.getAttribute('class').indexOf('_button_loading') !== -1;
            if (isLoading && !currentlyLoading) {
              // Loading finished
              // Here we can trigger a cart update or any other action
              const event = new Event('brilliant:addToCartComplete');
              document.dispatchEvent(event);
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'amplify-widget-brilliant'
              })

              const cartDrawerItems = document.querySelector('cart-drawer-items');
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawerItems) {
                cartDrawerItems.onCartUpdate();
              }

              if (cartDrawer) {
                const sections = cartDrawer.getSectionsToRender().map((section) => section.id)
                fetch(`${routes.cart_url}?sections=${sections.join(',')}`)
                  .then((response) => response.json())
                  .then((response) => {
                    cartDrawer.renderContents({id: null, sections: response});
                    cartDrawer.classList.remove('is-empty');
                    cartDrawer.open();
                  });
              }
            }
            isLoading = currentlyLoading;
          }
        }
      });
      observer.observe(addButton, { attributes: true });
    }
    
    pickyWidget.classList.add('brilliant-initialized');

    const updateOptions = () => {
      const productOptions = productElement.querySelectorAll('[data-option-value-id]');
      const firstOption = pickyWidget.querySelector('.picky-qb-bundle__qb-offer-item');
      const pickyOptions = firstOption.querySelectorAll('[data-option-id]');
      productOptions.forEach((opt) => {
        const isSelected = opt.checked || opt.tagName.toLowerCase() === 'select'
        if (!isSelected) {
          return
        }
        const fieldset = opt.closest('fieldset');
        const optionIndex = Array.prototype.indexOf.call(fieldset.parentElement.children, fieldset);
        
        const correspondingOption = pickyOptions[optionIndex];
        const selectElement = correspondingOption.querySelector('select');
        if (selectElement) {
          selectElement.value = opt.value;
          selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const optionInputs = correspondingOption.querySelectorAll('input[type="radio"]');
          optionInputs.forEach((input) => {
            if (input.value === opt.value) {
              input.checked = true;
            }
          });
        }
      });
    };

    const onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      updateOptions
    );

    
    // Initial update
    updateOptions();
  }
  
  if (pickyWidget) {
    onPickyExists();
    return;
  }
  
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList.contains('picky-qb-bundle')) {
              pickyWidget = node;
              onPickyExists();
              observer.disconnect(); // Stop observing after finding the element
            }
          }
        });
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
})();